import type { NuxtApp } from '#app';
import { useSiteStore } from '~/stores/site.store';

export const useLocaleService = (nuxt?: NuxtApp) => {
  const { $fetch } = useNuxtApp();
  const { setLocaleCode, setLocale } = useLocaleUtils();
  const siteStore = useSiteStore(nuxt?.$pinia);
  const fetchLocale = async (localeCode: string) => {
    if (!localeCode) {
      try {
        const cultures = !siteStore.getConfig?.cultures?.length
          ? siteStore.getConfig?.Cultures
          : siteStore.getConfig?.cultures;

        localeCode = cultures[0]['cultureCode'] || cultures[0]['CultureCode'];
      } catch (e) {
        localeCode = 'en-US';
        console.error(e);
      }
    }

    return await $fetch<Record<string, string>>(
      `cron/locales/jackpotcity/${localeCode}`,
      {
        base: 'config',
        keepalive: true,
        onResponse({ response }) {
          setLocaleCode(localeCode);
          setLocale(response?._data);
        },
        onRequestError(context) {
          console.error('[REQUEST ERROR]:', context);
        },
      },
    );
  };
  return { fetchLocale };
};
